import {
  BOOKING_ENGINE_TYPES,
  isBookingEngineType as isGeneratedBookingEngineType,
  type BookingEngineType as GeneratedBookingEngineType,
} from '@quoruum/frontend-common/oas/gen/enumValues.gen';

export type BookingEngineType = GeneratedBookingEngineType;
export const BOOKING_ENGINE_TYPE_OPTIONS: ReadonlyArray<BookingEngineType> = [
  ...BOOKING_ENGINE_TYPES,
];
export const isBookingEngineType = isGeneratedBookingEngineType;
